<template>
  <g>
    <path
      d="M5 11.0002H9C10.1 11.0002 11 10.1002 11 9.00024V5.00024C11 3.90024 10.1 3.00024 9 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024V9.00024C3 10.1002 3.9 11.0002 5 11.0002ZM5 5.00024H9V9.00024H5V5.00024Z"
    />
    <path
      d="M5 21.0002H9C10.1 21.0002 11 20.1002 11 19.0002V15.0002C11 13.9002 10.1 13.0002 9 13.0002H5C3.9 13.0002 3 13.9002 3 15.0002V19.0002C3 20.1002 3.9 21.0002 5 21.0002ZM5 15.0002H9V19.0002H5V15.0002Z"
    />
    <path
      d="M13 5.00024V9.00024C13 10.1002 13.9 11.0002 15 11.0002H19C20.1 11.0002 21 10.1002 21 9.00024V5.00024C21 3.90024 20.1 3.00024 19 3.00024H15C13.9 3.00024 13 3.90024 13 5.00024ZM19 9.00024H15V5.00024H19V9.00024Z"
    />
    <path
      d="M21 20.5002V19.5002C21 19.2202 20.78 19.0002 20.5 19.0002H19.5C19.22 19.0002 19 19.2202 19 19.5002V20.5002C19 20.7802 19.22 21.0002 19.5 21.0002H20.5C20.78 21.0002 21 20.7802 21 20.5002Z"
    />
    <path
      d="M13 13.5002V14.5002C13 14.7802 13.22 15.0002 13.5 15.0002H14.5C14.78 15.0002 15 14.7802 15 14.5002V13.5002C15 13.2202 14.78 13.0002 14.5 13.0002H13.5C13.22 13.0002 13 13.2202 13 13.5002Z"
    />
    <path
      d="M16.5 15.0002H15.5C15.22 15.0002 15 15.2202 15 15.5002V16.5002C15 16.7802 15.22 17.0002 15.5 17.0002H16.5C16.78 17.0002 17 16.7802 17 16.5002V15.5002C17 15.2202 16.78 15.0002 16.5 15.0002Z"
    />
    <path
      d="M13 17.5002V18.5002C13 18.7802 13.22 19.0002 13.5 19.0002H14.5C14.78 19.0002 15 18.7802 15 18.5002V17.5002C15 17.2202 14.78 17.0002 14.5 17.0002H13.5C13.22 17.0002 13 17.2202 13 17.5002Z"
    />
    <path
      d="M15.5 21.0002H16.5C16.78 21.0002 17 20.7802 17 20.5002V19.5002C17 19.2202 16.78 19.0002 16.5 19.0002H15.5C15.22 19.0002 15 19.2202 15 19.5002V20.5002C15 20.7802 15.22 21.0002 15.5 21.0002Z"
    />
    <path
      d="M17.5 19.0002H18.5C18.78 19.0002 19 18.7802 19 18.5002V17.5002C19 17.2202 18.78 17.0002 18.5 17.0002H17.5C17.22 17.0002 17 17.2202 17 17.5002V18.5002C17 18.7802 17.22 19.0002 17.5 19.0002Z"
    />
    <path
      d="M18.5 13.0002H17.5C17.22 13.0002 17 13.2202 17 13.5002V14.5002C17 14.7802 17.22 15.0002 17.5 15.0002H18.5C18.78 15.0002 19 14.7802 19 14.5002V13.5002C19 13.2202 18.78 13.0002 18.5 13.0002Z"
    />
    <path
      d="M19.5 17.0002H20.5C20.78 17.0002 21 16.7802 21 16.5002V15.5002C21 15.2202 20.78 15.0002 20.5 15.0002H19.5C19.22 15.0002 19 15.2202 19 15.5002V16.5002C19 16.7802 19.22 17.0002 19.5 17.0002Z"
    />
  </g>
</template>
